import { Array, Number, Record, String } from "runtypes";
import { orderSemesters, semesterFromComponents } from "./semesters";
export const CourseName = Record({
  year: Number,
  semester: String,
  department: String,
  number: String
});
export const courseNameToPath = (name) => `${name.year}/${name.semester}/${name.department}/${name.number}`;
export const Course = CourseName.And(
  Record({
    path: String,
    sections: Array(Record({ CRN: String, name: String }))
  })
);
export const filterCourses = (courses, department, number) => courses.filter((course) => {
  return course.department === department && course.number === number;
});
export const coursesBefore = (courses, sem) => courses.filter(
  ({ year, semester }) => orderSemesters(semesterFromComponents(year.toString(), semester), sem) < 0
);
export const CS124FromSemester = (semester) => {
  return CourseName.check({ department: "CS", number: "124", year: semester.year, semester: semester.name });
};
//# sourceMappingURL=course.js.map
